// @need-translate
import {ColorMode} from '../../colorMode/ColorMode.enum';

export const COLOR_MODE_TEXT_MAP: {[key in ColorMode]: string} = {
  [ColorMode.Dark]: '다크모드',
  [ColorMode.Light]: '라이트모드',
  [ColorMode.System]: '시스템모드',
};
